import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { getTheme, noSelect } from 'helpers'
import { get } from 'lodash'

@connect(state => ({
  suffixes: get(state, 'app.suffixes') || {}
}))
export default class extends Component {
  _onTabChange = (key) => {
    const { history, suffixes } = this.props
    const suffix = suffixes[key] || ''
    history.replace(`/${key}${suffix}`)
  }

  render () {
    const { visible, activeKey, menus } = this.props
    return visible ? (
      <Bar>
        {menus.map(({ title, key }) =>
          <TabMenu key={key} active={activeKey === key} onClick={() => this._onTabChange(key)}>{title}</TabMenu>
        )}
      </Bar>
    ) : null
  }
}

const Bar = styled.div`
  position: fixed;
  bottom: -2px;
  left: 0px;
  right: 0px;
  height: 50px;
  z-index: 9998;
  background-color: white;
  border-top: 1px solid ${getTheme`colorBorder`};
  @media(min-width: 768px) { display: none; }
`
const TabMenu = styled.div`
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 33.33%;
  line-height: 51px;;
  text-align: center;
  font-size: 14px;
  ${noSelect}
  ${props => props.active && `
    color: ${props.theme.colorTiffany};
    &:after {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      height: 5px;
      background-color: ${props.theme.colorTiffany};
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/TabBar.js